import { ROUTES } from "constants/routes";

export const gestionPath = (customerId, suffix = "") => `${ROUTES.ADMIN.GESTION}/${customerId}${suffix}`;

export const GESTION_ROUTES = {
  dashboard: (customerId) => gestionPath(customerId),
  competitions: (customerId) => gestionPath(customerId, "/tournaments"),
  tournaments: (customerId) => gestionPath(customerId, "/tournaments"),
  tournamentsCreate: (customerId) => gestionPath(customerId, "/tournaments/create"),
  tournament: (customerId, tournamentId) => gestionPath(customerId, `/tournaments/${tournamentId}`),
  competition: (customerId, competitionId, suffix = "") =>
    gestionPath(customerId, `/competitions/${competitionId}${suffix}`),
  teams: (customerId) => gestionPath(customerId, "/teams"),
  team: (customerId, teamId) => gestionPath(customerId, `/teams/${teamId}`),
  teamFinancials: (customerId, teamId) => gestionPath(customerId, `/teams/${teamId}/financials`),
  players: (customerId) => gestionPath(customerId, "/players"),
  playerFinancials: (customerId, memberId) => gestionPath(customerId, `/players/${memberId}/financials`),
  entityFinancials: (customerId, entityId) =>
    gestionPath(customerId, `/financials/accounts/${encodeURIComponent(entityId)}`),
  individualFinancials: (customerId, entityId, individualId) =>
    gestionPath(
      customerId,
      `/financials/accounts/${encodeURIComponent(entityId)}/${encodeURIComponent(individualId)}`,
    ),
  matches: (customerId) => gestionPath(customerId, "/matches"),
  branding: (customerId) => gestionPath(customerId, "/settings/app"),
  settings: (customerId) => gestionPath(customerId, "/settings"),
  settingsApp: (customerId) => gestionPath(customerId, "/settings/app"),
  financials: (customerId) => gestionPath(customerId, "/financials"),
  notifications: (customerId) => gestionPath(customerId, "/notifications"),
  membershipSettings: (customerId) => gestionPath(customerId, "/financials?tab=membership"),
  financialPayment: (customerId, paymentId) => gestionPath(customerId, `/financials/payments/${paymentId}`),
  migration: (customerId) => gestionPath(customerId, "/migration"),
  venues: (customerId) => gestionPath(customerId, "/settings"),
};
